/* Materials library fan-deck — upgrades server-rendered anchors/articles to the
   ARIA tabs pattern. Without JS the anchors stay jump links and every panel is
   visible (the section only hides panels once its data-js flag is set). */
(function () {
  'use strict';

  function initDeck(root) {
    var list = root.querySelector('[data-deck-list]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-deck-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-deck-panel]'));
    if (!list || tabs.length === 0 || tabs.length !== panels.length) return;

    list.setAttribute('role', 'tablist');
    tabs.forEach(function (tab, i) {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panels[i].id);
      panels[i].setAttribute('role', 'tabpanel');
      panels[i].setAttribute('aria-labelledby', tab.id);
      panels[i].setAttribute('tabindex', '0');
    });

    function select(index, focus) {
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        panels[i].classList.toggle('is-active', active);
      });
      if (focus) {
        tabs[index].focus();
        tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    /* Panel pager (prev/next) — steps materials, syncs deck state, keeps focus
       on the equivalent button in the newly shown panel. */
    function step(delta, source) {
      var next = (current + delta + tabs.length) % tabs.length;
      current = next;
      select(next, false);
      tabs[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      var selector = source.hasAttribute('data-deck-prev') ? '[data-deck-prev]' : '[data-deck-next]';
      var twin = panels[next].querySelector(selector);
      if (twin) twin.focus();
    }
    root.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-deck-prev]');
      if (prev) { step(-1, prev); return; }
      var next = e.target.closest('[data-deck-next]');
      if (next) step(1, next);
    });

    var current = 0;
    tabs.forEach(function (tab, i) {
      if (tab.classList.contains('is-active')) current = i;

      tab.addEventListener('click', function (e) {
        e.preventDefault();
        current = i;
        select(i, false);
      });

      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        current = next;
        select(next, true);
      });
    });

    select(current, false);
  }

  function init() {
    document.querySelectorAll('[data-materials-deck]').forEach(initDeck);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when the theme editor re-renders the section */
  document.addEventListener('shopify:section:load', function (e) {
    var deck = e.target.querySelector('[data-materials-deck]');
    if (deck) initDeck(deck);
  });
})();
